import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { ReportBlockTypeEnum } from '../enums/report-block-type.enum';

export class ChartOptionModel {
    label: string;
    value: string;
    multiSeries?: boolean;
    permissions: userPermissionsEnum[] = [];

    constructor(
        label?: string,
        value?: ReportBlockTypeEnum,
        multipleSeries?: boolean,
        permissions?: userPermissionsEnum[]
    ) {
        this.label = label;
        this.value = value;
        this.multiSeries = multipleSeries;
        this.permissions = permissions ?? [];
    }

    hasPermission(permission: userPermissionsEnum): boolean {
        return this.permissions.includes(permission);
    }
}
